/**
 * @module  experience/shop
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

// Core Libraries
import { Injectable, EventEmitter } from '@angular/core';

// Services
import { MatchmediaService } from '@core/public';

@Injectable()
export class PurchasePathService {
  /**
   * Flag for getting multi line plans in case of creating new tile.
   */
  public reloadMultiLinePlans: EventEmitter<boolean>;
  /**
   * Stores selected Index
   */
  private selectedIndex: number;

  constructor(private matchmediaService: MatchmediaService) {
    this.reloadMultiLinePlans = new EventEmitter<boolean>();
    this.selectedIndex = 0;
  }

  /**
   * Method to get Selected Line Index
   * @returns number
   */
  public getSelectedLineIndex(): number {
    return this.selectedIndex;
  }

  /**
   * Method to set Selected Line Index
   * @returns number
   */
  public setSelectedLineIndex(index: number): void {
    this.selectedIndex = index;
  }

  /**
   * This method is used get limit of char on th basis on device type
   * @param None
   * @returns number
   */
  public detailCharLimit(): number {
    // @TODO we will remove this logic with short description and long descrition for see more/less functionality
    // TODO: need to fix desktopLimit after clarification from TPO.
    const desktopLimit = 114;
    const tabletLimit = 71;
    if (this.matchmediaService.isTablet()) {
      return tabletLimit;
    } else {
      return desktopLimit;
    }
  }
}
